"use strict";

var _interopRequireWildcard = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePageId = exports.PageIdContextProvider = void 0;
exports.withPageIdContext = withPageIdContext;
var _react = _interopRequireWildcard(require("react"));
var PageSettingsContext = /*#__PURE__*/(0, _react.createContext)('');
var PageIdContextProvider = function PageIdContextProvider(_ref) {
  var pageId = _ref.pageId,
    children = _ref.children;
  return /*#__PURE__*/_react.default.createElement(PageSettingsContext.Provider, {
    value: pageId
  }, children);
};
exports.PageIdContextProvider = PageIdContextProvider;
function withPageIdContext(Component, pageId) {
  // eslint-disable-next-line react/display-name
  return function (props) {
    return /*#__PURE__*/_react.default.createElement(PageIdContextProvider, {
      pageId: pageId
    }, /*#__PURE__*/_react.default.createElement(Component, props));
  };
}
var usePageId = function usePageId() {
  return (0, _react.useContext)(PageSettingsContext);
};
exports.usePageId = usePageId;